import { WS_CONNECT, WS_DISCONNECT } from './constants';

export const wsConnect = () => ({ type: WS_CONNECT });

export const wsDisconnect = () => ({ type: WS_DISCONNECT });
